import { render, staticRenderFns } from "./AudioNoticeboardVoiceSettings.vue?vue&type=template&id=6f85844d&"
import script from "./AudioNoticeboardVoiceSettings.vue?vue&type=script&lang=js&"
export * from "./AudioNoticeboardVoiceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports